<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader" *ngIf="document"></app-content-header>
    <div class="card col-12 p-1" *ngIf="document">
      <div class="row justify-content-between px-1" [ngClass.sm]="'align-items-center'">
        <div>
          <label class="font-small-4 font-weight-bold">{{ "CATEGORY" | translate }}:</label>
          <p class="font-medium-1 mb-0" [ngClass.sm]="'mb-1'">{{ document.document_data.category }}</p>
        </div>
        <div [ngClass.xl]="'ml-2'">
          <label class="font-small-4 font-weight-bold">{{ "DATE" | translate }}:</label>
          <p class="font-medium-1 mb-0" [ngClass.sm]="'mb-1'">{{ _utilService.formatDate(document.document_data.send_date, "DD/MM/YY") }}</p>
        </div>
        <div [ngClass.xl]="'ml-2'">
          <label class="font-small-4 font-weight-bold">{{ "REQUIRED_SIGNATURE" | translate }}:</label>
          <span class="text-success ml-025" [data-feather]="'check'" size="20" *ngIf="document.document_data.require_signature"></span>
          <span class="text-danger ml-025" [data-feather]="'x'" size="20" *ngIf="!document.document_data.require_signature"></span>
          <div>
            <label class="font-small-4 font-weight-bold">{{ "REQUIRED_ACCEPTION" | translate }}:</label>
            <span class="text-success ml-025" [data-feather]="'check'" size="20" *ngIf="document.document_data.require_acception"></span>
            <span class="text-danger ml-025" [data-feather]="'x'" size="20" *ngIf="!document.document_data.require_acception"></span>
          </div>
        </div>
        <div>
          <span class="badge badge-pill badge-light-warning mr-1" *ngIf="document.document_user_data.signed == 1 && document.document_data.require_signature == 1 && document.document_user_data.status == 0">
            {{ "SIGNATURE_TO_APPROVE" | translate }}
          </span>
          <span class="badge badge-pill badge-light-success mr-1" *ngIf="document.document_user_data.signed == 1 && document.document_data.require_signature == 1 && document.document_user_data.status == 1">
            {{ "APPROVED" | translate }}
          </span>
          <span class="badge badge-pill badge-light-danger mr-1" *ngIf="document.document_user_data.signed == 1 && document.document_data.require_signature == 1 && document.document_user_data.status == 2">
            {{ "REJECTED" | translate }}
          </span>
          <span
            class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(document.document_data.end_date) ? 'danger' : 'warning' }} mr-1"
            *ngIf="document.document_data.end_date && document.document_user_data.signed == 0 && document.document_data.require_signature == 1"
          >
            {{ "NOT_SIGNED" | translate }} {{ "WITHIN" | translate }} {{ _utilService.formatDate(document.document_data.end_date, "DD/MM/YY") }}
          </span>
          <span class="badge badge-pill badge-light-danger mr-1" *ngIf="!document.document_data.end_date && document.document_user_data.signed == 0 && document.document_data.require_signature == 1">
            {{ "NOT_SIGNED" | translate }}
          </span>

          <span class="badge badge-pill badge-light-success mr-1" *ngIf="document.document_user_data.having_read == 1 && document.document_data.require_acception == 1">
            {{ "VIEWED" | translate }}
          </span>
          <span
            class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(document.document_data.end_date) ? 'danger' : 'warning' }} mr-1"
            *ngIf="document.document_user_data.having_read == 0 && document.document_data.require_acception == 1 && document.document_data.end_date"
          >
            {{ "NOT_VIEWED" | translate }}
            {{ "WITHIN" | translate }} {{ _utilService.formatDate(document.document_data.end_date, "DD/MM/YY") }}
          </span>
          <span
            class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(document.document_data.end_date) ? 'danger' : 'warning' }} mr-1"
            *ngIf="document.document_user_data.having_read == 0 && document.document_data.require_acception == 1 && !document.document_data.end_date"
          >
            {{ "NOT_VIEWED" | translate }}
          </span>
        </div>
        <div class="col-12 pl-0" *ngIf="!!document.document_data.description">
          <label class="font-small-4 font-weight-bold">{{ "DESCRIPTION" | translate }}:</label>
          <p class="font-medium-1">{{ document.document_data.description }}</p>
        </div>
        <div class="col-12 pl-0" *ngIf="document.document_user_data.status_note && document.document_user_data.status_note.length > 0">
          <label class="font-small-4 font-weight-bold">{{ "NOTE" | translate }}:</label>
          <p class="font-medium-1">{{ document.document_user_data.status_note }}</p>
        </div>
      </div>
    </div>

    <iframe [src]="document.file_url" frameborder="0" *ngIf="document && document.file_url"></iframe>

    <div class="d-flex card-footer bg-white justify-content-end align-items-center">
      <!--bottone presa visione del documento-->
      <div *ngIf="document && document.document_data.require_acception == 1 && document.document_data.require_signature == 0 && document.document_user_data.having_read == 0">
        <div class="custom-control custom-control-primary custom-switch">
          <small class="mr-025">{{ "DECLARE_ACKNOWLEDGE" | translate }}</small>
          <input (click)="setReadDocument()" type="checkbox" class="custom-control-input having_read" id="acknowledgment" [disabled]="documentReaded" />
          <label class="custom-control-label" for="acknowledgment"> </label>
        </div>
      </div>
      <!--bottone download-->
      <div class="ml-2">
        <button class="btn btn-outline-primary" (click)="download(document.path_file)">{{ "DOWNLOAD" | translate }}</button>
      </div>
      <!--carica documento-->
      <div class="custom-file w-25 mx-2" *ngIf="document && document.document_data.require_signature == 1 && document.document_user_data.signed == 0">
        <input class="custom-file-input" #documentFile type="file" id="actual-btn" lang="it" accept="application/pdf" [(ngModel)]="fileAdd" (change)="handlerChangeFileInput($event)" hidden />
        <label *ngIf="!documentFile.value" for="actual-btn" class="custom-file-label">{{ "INSERT.UPLOAD_DOCUMENT" | translate }}</label>
        <label *ngIf="documentFile.value.length > 0" for="actual-btn" class="custom-file-label">{{ documentFile.value.replace("C:\\fakepath\\", "") }}</label>
      </div>
      <!--invia documento firmato-->
      <div *ngIf="document && document.document_data.require_signature == 1 && document.document_user_data.signed == 0">
        <button class="btn btn-outline-primary" (click)="sendSignedDocument()" [disabled]="!fileAdd">{{ "SEND_SIGNED_DOCUMENT" | translate }}</button>
      </div>
    </div>
  </div>
</div>
